import * as yup from 'yup';

const validationSchema = yup.object({
  vimeoUrl: yup.string().required('Required'),
});

export default validationSchema;
